'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var seo = exports.seo = {
  title: 'Tutellus',
  description: 'Aprende para ser mejor. Videoformación práctica de todo lo que necesitas',
  type: 'website',
  image: 'https://dev-res.thumbr.io/images/default-seo-image.jpg',
  app: 'Tutellus',
  robots: 'index,follow',
  twitter: 'tutellus',
  www_url: 'https://www.tutellus.com',
  intl_url: 'https://intl.tutellus.com'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/seo.js
// module id = 707
// module chunks = 0